import { Component } from '@felicity/vision';
import { UnitOfMeasureManager } from '@felicity/standards';

/**
 * Units of Measure screen
 */
export default class UnitsOfMeasure extends Component {
  /**
   * Provides access to the unit of measure manager
   * @type {UnitOfMeasureManager}
   */
  get unitOfMeasureManager() {
    return this.#manager;
  }

  /** @type {UnitOfMeasureManager} */
  #manager;

  constructor() {
    super();

    this.#manager = new UnitOfMeasureManager();
    this.unitOfMeasureManager.crudUri = '/api/Standards/UnitOfMeasure';
    this.unitOfMeasureManager.checkmarkIconClass = 'e-check';
  }

  _prepare() {
    super._prepare();
    this.classList.add('screen');

    this.appendChild(this.unitOfMeasureManager);
    this.unitOfMeasureManager.grid.height = '100%';
    this.unitOfMeasureManager.grid.width = '100%';
  }
}

UnitOfMeasureManager.register('unit-of-measure-manager');
